<template>
<div>
  <div class="flex flex-wrap justify-center md:mt-4 md:mb-4">
    <span class="block mb-4 text-center text-xl md:text-4xl font-bold tracking-tight text-gray-700 dark:text-white">News of Simpleish</span>
    <span class="block mb-4 text-center text-4xl md:text-7xl font-bold tracking-tight text-gray-700 dark:text-white">Remove Background in Seconds</span>
  </div>
  <div class="flex flex-wrap justify-center md:mt-10 md:mb-10">
    <div class="md:h-full md:w-1/2 pl-2 pr-2">
      <div id="slider" class="beer-slider" data-beer-label="before">
        <img src="../assets/images/news2.png" class="transparent" alt="">
        <div class="beer-reveal" data-beer-label="after">
          <img src="../assets/images/news1.jpeg" alt="">
        </div>
      </div>
    </div>
    <div class="md:h-full md:w-1/2 pl-2 pr-2 m-auto">
      <span style="font-size:24px; font-weight:bold;">Visualize your news content...</span>
      <p style="font-size:18px; padding:20px;">We are provide you the foreground subjects 
        in order to you to place them anywhere in your photos via our strong AI power on <strong>simpleish.io</strong>.</p>
    </div>
  </div>

  <hr>

  <div class="flex flex-wrap justify-center md:mt-10 md:mb-10">
    <div class="md:h-full md:w-1/2 pl-2 pr-2 m-auto">
      <span style="font-size:24px; font-weight:bold;">Smooth away easily from backgrounds without using a software.</span>
      <p style="font-size:16px;"></p>
    </div>
    <div class="md:h-full md:w-1/2 pl-2 pr-2">
      <img src="../assets/images/news_api.png" class="transparent" alt=""/>
    </div>
  </div>
</div>
</template>

<script>

export default {
  name: "News",
  components: {
  },
  props: {
  },
  data() {
    return {
      origin: 'http://localhost:8080',
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  mounted: function () {
    let externalScript = document.createElement('script')
    externalScript.setAttribute('src', 'https://unpkg.com/beerslider/dist/BeerSlider.js')
    document.head.appendChild(externalScript);

    externalScript.onload = () => {
          new window.BeerSlider( document.getElementById( "slider" ) )
        };
  },
  methods: {
    
  },
};
</script>